import cx from 'classnames'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useGetActiveFollowingsQuery } from 'store/api/yay/user'
import { useCurrentUser } from 'store/api/yay/user'

import useChatRoomLogic from 'features/Chat/hocs/useChatRoomLogic'
import { Link } from 'features/i18n/router'
import usePageModal from 'features/Modal/hooks/usePageModal'
import { snowplowEvent } from 'lib/analytics'

import { UserList } from 'components'

import { ReactComponent as CaretIcon } from 'icons/icon-caret-down.svg'
import { ReactComponent as CheckIcon } from 'icons/icon-check.svg'

import Menu from 'components/Menu'

import { MODAL_MODE } from '../../config'

import { HimanowListBox } from 'features/Himanow'
import './style.scss'

export const UsersDiscovery = () => {
  const { t } = useTranslation()
  const { data: currentUser } = useCurrentUser()
  const isHimanowFeatureEnable = currentUser?.country_code === 'JP'

  const [selectedOption, setSelectedOption] = useState<
    'followings' | 'himanow'
  >('followings')
  const { onCreateChatRoom } = useChatRoomLogic()
  const { generatePageModalUrl } = usePageModal()

  const activeFollowings = useGetActiveFollowingsQuery({
    onlyOnline: true,
  })

  return (
    <div className="UsersDiscovery">
      <div className="UsersDiscovery__header">
        {isHimanowFeatureEnable ? (
          <Menu
            handlerElement={({ onClick, isMenuOpen }) => (
              <a
                onClick={() => onClick()}
                className="ChatListModal__menu__handler"
              >
                <strong>
                  {selectedOption === 'followings'
                    ? t('chat_list_modal.followings.title')
                    : t('chat_list_modal.himanow.title')}
                </strong>

                <CaretIcon
                  className={cx(
                    'ChatListModal__menu__handler__icon',
                    isMenuOpen && 'ChatListModal__menu__handler__icon--active'
                  )}
                />
              </a>
            )}
            options={[
              {
                title: (
                  <div
                    className={cx(
                      'ChatListModal__menu__handler__option',
                      selectedOption === 'followings' &&
                        'ChatListModal__menu__handler__option--active'
                    )}
                  >
                    <CheckIcon />{' '}
                    <span>{t('chat_list_modal.followings.title')}</span>
                  </div>
                ),
                onClick: () => setSelectedOption('followings'),
              },
              {
                title: (
                  <div
                    className={cx(
                      'ChatListModal__menu__handler__option',
                      selectedOption === 'himanow' &&
                        'ChatListModal__menu__handler__option--active'
                    )}
                  >
                    <CheckIcon />{' '}
                    <span>{t('chat_list_modal.himanow.title')}</span>
                  </div>
                ),
                onClick: () => setSelectedOption('himanow'),
              },
            ]}
            openDownwards
            hideArrow
            theme="white"
            panelPosition="down"
          />
        ) : (
          <strong>{t('chat_list_modal.followings.title')}</strong>
        )}

        {selectedOption === 'followings' && (
          <Link
            className="UsersDiscovery__header__link"
            to={generatePageModalUrl(MODAL_MODE.NEW_CHAT)}
          >
            {t('common.see_more_user')}
          </Link>
        )}

        {selectedOption === 'himanow' && (
          <Link
            className="UsersDiscovery__header__link"
            to={generatePageModalUrl(MODAL_MODE.HIMANOW_USER_LIST, {
              goBack: true,
            })}
            onClick={() => snowplowEvent.open_himanow()}
          >
            {t('common.see_more_user')}
          </Link>
        )}
      </div>

      {selectedOption === 'followings' && (
        <>
          {activeFollowings.isSuccess &&
            (activeFollowings?.data?.users ?? []).length === 0 && (
              <p>{t('chat_list_modal.followings.empty')}</p>
            )}
          <UserList
            users={activeFollowings?.data?.users ?? []}
            mode="scroll"
            onClick={(user) =>
              onCreateChatRoom({
                userId: user.id,
                goBack: true,
                from: 'online_following',
              })
            }
            showOnlineStatus
            hideNicknameTags
          />
        </>
      )}

      {selectedOption === 'himanow' && <HimanowListBox />}
    </div>
  )
}
